import React, { Component } from 'react'
import Loader from 'react-loader-spinner'
import CustomLoader from '../CustomLoader'
import { checkTranslation } from '../../utils/useful'


export default class ButtonAnimated extends Component {

    state = {}

    componentDidUpdate() {
    }

    onClick = () => {
        if (!this.props.isLoading) {
            this.props.onClick()
        }
    }
    render() {
        return (
            <button onClick={() => { if (!this.props.disabled && !this.state.isLoading) { this.onClick() } }} style={{ border: this.props.border, background: this.props.bg, width: this.props.width, height: 34 }} className={' br-30  py-0 pld-0 ' + ((!this.props.isLoading ? 'btn-right-animated' : 'btn-right-animated2') + (this.props.className ? ` ${this.props.className} ` : ''))} >
                <div className='flexcc'>
                    <p className={'white text-small px-3 w-100 text-semibold ' + ((this.props.icon || this.props.isLoading) ? 'mrd-0' : 'mrd-0')} style={{ color: this.props.textColor, whiteSpace: "nowrap", fontSize: this.props.fontSize }}>{checkTranslation(this.props.title)}</p>
                    {(this.props.icon || this.props.isLoading) ? (
                        <div className=' rotate-0'>
                            <div className='arrow-box br-30 flexcc px-1' style={{ width: 24, height: 24, background: this.props.invert ? '#0000001d' : '#ffffff1d' }}>
                                {!this.props.isLoading ? (
                                    <img className={'' + (this.props.invert ? 'invert' : '')} style={{ width: 24 }} src={this.props.icon} alt='' />
                                ) : (
                                    <div className='flexcc ' style={{ width: '28px', aspectRatio: '1 / 1' }}>
                                        <CustomLoader color={"#fff"} isLoading={true} width={27} type={"Oval"} className={'flexcc'} />
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div></div>
                    )}
                </div>
            </button>
        )
    }
}
